module.exports = __webpack_public_path__ + "media/images/alf_bg-334c8877a4cd2c4e63e306d52378c8fe.svg";